module.exports = __webpack_public_path__ + "img/savings.442173c.svg";